export const Utils = {
    chaeckPasswordStrength(val, errorMessage = "") {

        if (errorMessage === "") {
            errorMessage = "Password should have at least: 8 characters including, 1 upper case, 1 special character (!@#$&*), and 1 number.";
        }
        if (typeof val != 'string') {
            return errorMessage;
        }
        if ((val = val.trim()).length == 0) {
            return errorMessage;
        }


        // 8 characters length
        // 1 characters in Upper Case
        // 1 Special Character (!@#$&*)
        // 1 numerals (0-9)
        var res = val.match(
            /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9]).{8}/
        );
        if (res) {
            return true;
        } else {
            return errorMessage;
        }
    },
    bigNumberFormat(n, d) {
        //https://stackoverflow.com/questions/9345136/1000000-to-1m-and-1000-to-1k-and-so-on-in-js
        let x = ('' + n).length;
        let p = Math.pow;
        d = p(10, d);
        x -= x % 3;
        return (Math.round(n * d / p(10, x)) / d) + " kMGTPE"[x / 3];
    },
    comma(val) {
        //https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
        var t = parseFloat(val);
        var bt = t.toLocaleString();
        return bt;
    },

    formatDate(date, format, useUTC = null) {
        if (!date || (typeof date == 'string' && date == "")) {
            return date;
        }

        // Auto-detect if the string is UTC formatted
        if (useUTC === null && typeof date === 'string') {
            // Check for 'Z' at the end or timezone offsets which indicate UTC format
            if (date.endsWith('Z') || date.match(/[+-]\d{2}:\d{2}$/)) {
                useUTC = true;
            } else {
                useUTC = false;
            }
        }

        // Default to true if still null
        if (useUTC === null) {
            useUTC = true;
        }

        if (typeof date == 'string') {
            date = new Date(date);
        }

        const shortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        // Use UTC or local time based on the useUTC parameter
        let monthIndex = useUTC ? date.getUTCMonth() : date.getMonth();
        let dayStr = useUTC ? date.getUTCDate() : date.getDate();
        if (dayStr < 10) {
            dayStr = `0${dayStr}`;
        } else {
            dayStr = `${dayStr}`;
        }
        let montStr = "";
        if (monthIndex < 10) {
            montStr = `0${monthIndex + 1}`;
        } else {
            montStr = `${monthIndex + 1}`;
        }

        // Get hours using UTC if specified
        let hours = useUTC ? date.getUTCHours() : date.getHours();
        let hrStr = hours;
        var ampm = "AM";

        // Always convert to 12-hour format for display
        if (hours >= 12) {
            ampm = "PM";
            if (hours > 12) {
                hrStr = hours - 12;
            }
        } else if (hours === 0) {
            hrStr = 12; // 00:00 is 12:00 AM
        }

        if (hrStr < 10) {
            hrStr = `0${hrStr}`;
        } else {
            hrStr = `${hrStr}`;
        }

        // Get minutes using UTC if specified
        let minStr = useUTC ? date.getUTCMinutes() : date.getMinutes();
        if (minStr < 10) {
            minStr = `0${minStr}`;
        } else {
            minStr = `${minStr}`;
        }

        const year = useUTC ? date.getUTCFullYear() : date.getFullYear();

        if (format === "month date, year") {
            return `${shortNames[monthIndex]} ${dayStr},  ${year}`;
        } else if (format === "month date, year hrs:mins") {
            return `${shortNames[monthIndex]} ${dayStr},  ${year} ${hrStr}:${minStr} ${ampm}`;
        } else if (format === "mm-dd-yy") {
            return `${montStr}-${dayStr}-${year}`;
        } else if (format === "mm-dd-yy hrs:mins") {
            return `${montStr}-${dayStr}-${year} ${hrStr}:${minStr} ${ampm}`;
        }
        return useUTC ? date.toUTCString() : date.toDateString();
    },
    getLastWeeksDate() {
        //https://bobbyhadz.com/blog/javascript-get-last-week-date
        const now = new Date();

        return new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate() - 7 //supposed to be 7 
        );
    },
    isLessThanMonth(date, fromDate) {
        const itemDate = typeof date === 'string' ? new Date(date) : date;
        fromDate = !fromDate ? new Date() : fromDate;
        // const acceptedTimeSpan = 30 * 24 * 60 * 60 * 1000 ; //todo: 30 days
        // const acceptedTimeSpan = 30 * 24 * 60 * 60 * 1000 * 2; //two months
        const acceptedTimeSpan = 7 * 24 * 60 * 60 * 1000; //weeks time
        let timeDiffInMs = fromDate.getTime() - itemDate.getTime();
        if (timeDiffInMs < 0) {
            //the item date is greater, newer
            //check if its within a week
            const nowTime = (new Date()).getTime();
            timeDiffInMs = nowTime - itemDate.getTime(); //makes sure that things are within a weeks time
            if (timeDiffInMs <= acceptedTimeSpan) {
                return true;
            }
            return false;
        }

        return false;
    },
    getForum(communities, comid, id) {
        let forum = null;
        let breadcrumbPages = [
            { name: 'Forums', href: '/dashboard', current: false },
        ];
        for (let index = 0; index < communities.length; index++) {
            const community = communities[index];
            if (community.id === comid && community.forums) {
                breadcrumbPages.push(
                    { name: community.title, href: '#', current: false }
                );
                for (let j = 0; j < community.forums.length; j++) {
                    const tempForum = community.forums[j];
                    if (tempForum.id === id) {
                        forum = tempForum;
                        break;
                    }
                }
                break;
            }
        }

        return {
            forum,
            breadcrumbPages
        };
    },
    getPost(communities, comid, id, pid) {
        let forumRes = this.getForum(communities, comid, id);
        let breadcrumbPages = forumRes.breadcrumbPages;
        breadcrumbPages[1].href = `/community/${comid}/forum/${id}`;
        let forum = forumRes.forum;
        let post = null;
        for (let index = 0; index < forum.posts.length; index++) {
            const tempPost = forum.posts[index];
            if (tempPost.id === pid) {
                breadcrumbPages.push(
                    { name: forum.title, href: '#', current: true }
                );
                post = tempPost;
                break;
            }
        }
        return {
            forum,
            breadcrumbPages,
            post
        };
    },
    getJob(jobsList, id) {
        let job = null;
        for (let index = 0; index < jobsList.length; index++) {
            const jobItem = jobsList[index];
            if (parseInt(jobItem.id) === parseInt(id)) {
                job = { ...jobItem };
                break;
            }
        }

        return job;
    },
    insertBreaks(text, interval) {
        return text.split("").reverse().reduce((acc, x) => {
            if (acc[acc.length - 1].length < interval) {
                acc[acc.length - 1] += x;
            } else {
                acc.push(x);
            }
            return acc;
        }, [""]).reduce((acc, seg) => {
            acc.push(seg.split("").reverse().join(""));
            return acc;
        }, []).reverse().join("<wbr/>");
    },
    shuffle(array) {
        let currentIndex = array.length;

        // While there remain elements to shuffle...
        while (currentIndex != 0) {

            // Pick a remaining element...
            let randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
        }
    }
};

export const CommunicationBoardOptions = [
    {
        id: 1,
        name: 'Drawing Pad',
        icon: "https://openmoji.org/data/color/svg/1F4DD.svg",
        module: "drawing_pad",
        description: "Draw your own pictures. Start with a blank page or draw on top of a photo.",
        url: "/communication_tools/drawing_pad/communicationboard.html"
    },
    {
        id: 2,
        name: 'Keyboard',
        icon: "https://openmoji.org/data/color/svg/2328.svg",
        module: "wefayo_keyboard",
        description: "A simple keyboard to help you type and share your thoughts. You can change how it looks to fit your needs.",
        url: "/communication_tools/keyboard/communicationboard.html"
    },
    {
        id: 3,
        name: 'Wefayo Assistive Keyboard',
        icon: "/communication_tools/assistive_keyboard/WefayoAssistiveKeyboard.png",
        module: "wefayo_assistive_keyboard",
        description: "A typing environment built for neural diversity, with a cognitive reading pane, sensory support, sound and accessibility settings for ADHD, Autism, Dyslexia, Low Vision, and more",
        url: "/communication_tools/assistive_keyboard/communicationboard.html",
        iconHeight: "70px",
        minHeight: "70px",
        seeMoreContent: {
            title: "The World's First Unified Writing Environment for Neurodiversity",
            features: [
                "World-First Cognitive Reading Pane: Uses \"onset emphasis\" and line guides to help your brain decode and focus on words as you type.",
                "Complete Sensory Support: Custom color modes, high-contrast settings, and Text-to-Speech that reads letters and full passages out loud.",
                "Total Functional Independence: A built-in Clipboard allows you to type here and paste your message into any other app or website.",
                "Unified Support: Personalized settings for ADHD, Autism, Dyslexia, Low Vision, and Color Blindness, and easily distracted users.",
                "Anywhere Access: Use it on any computer, phone, or tablet at school, work, or the library."
            ],
        },
    },
    {
        id: 4,
        name: 'AAC Communication Board',
        icon: "https://static.arasaac.org/pictograms/36159/36159_500.png",
        module: "communication_board",
        description: "The AAC Communication Board is a tool that allows you to communicate with descriptive text and images.",
        url: "/communication_tools/normal_board/communicationboard.html"
    }
];

export const BlueEnvelopeProgramOptions = [
    //form, envelope, instructions, virtual form 

    {
        id: 0,
        name: 'Program Overview',
        icon: "https://openmoji.org/data/color/svg/1F4F0.svg",
        module: "overview",
        description: "Read this first. Learn what the program is.For anyone wanting to understand, participate, or help during a stop",
    },
    // {
    //     id: 3,
    //     name: 'Instructions',
    //     icon: "https://openmoji.org/data/color/svg/1F4C3.svg",
    //     module: "instructions",
    //     description: "A blue envelope program is a tool that allows you to send a blue envelope to a user.",
    //     url: "/blueEnvelopeInstructions.html",
    // },
    {
        id: 3,
        name: 'Pocket Card',
        icon: "https://openmoji.org/data/color/svg/1F4C3.svg",
        module: "card",
        description: "Print and carry this card always.Small card tells first responders your needs.Use it anytime a first responder approaches.",
        url: "/blueEnvelopeInstructions.html",
    },
    {
        id: 1,
        name: 'Driver\'s Form (Step 1)',
        icon: "https://openmoji.org/data/color/svg/1F4DD.svg",
        module: "form",
        description: "Fill out.  Print. Put it inside the Driver's Envelope.",
    },
    {
        id: 2,
        name: 'Driver\'s Envelope (Step 2)',
        icon: "https://openmoji.org/data/color/svg/2709.svg",
        module: "envelope",
        description: "Print. Fold. Put in car. Holds your form and car papers. Keep it easy to find. Give to first responders.",
    }, 
    
    // {
    //     id: 4,
    //     name: 'Virtual Form',
    //     icon: "https://openmoji.org/data/color/svg/1F4F0.svg",
    //     module: "virtual_form",
    //     description: "A blue envelope program is a tool that allows you to send a blue envelope to a user.",
    // },
];